const gallery = [
  require('../assets/gallery_image_1.png'),
  require('../assets/gallery_image_2.png'),
  require('../assets/gallery_image_3.png'),
  require('../assets/gallery_image_4.png'),
  require('../assets/image5.png'),
  require('../assets/car-image-6.jpg'),
  require('../assets/image5.png'),
  require('../assets/car-image-4.jpg'),
  require('../assets/car-image-4.jpg'),
  require('../assets/gallery_image_1.png'),
  require('../assets/gallery_image_2.png'),
  require('../assets/car-image-5.jpg'),
  require('../assets/car-image-6.jpg'),
  require('../assets/image5.png'),
  require('../assets/car-image-2.jpg'),
  require('../assets/car-image-3.jpg'),
  require('../assets/image5.png'),
  require('../assets/car-image-1.jpg'),
  require('../assets/car-image-2.jpg'),
  require('../assets/car-image-3.jpg'),
  require('../assets/image5.png'),
  require('../assets/car-image-5.jpg'),
  require('../assets/car-image-6.jpg'),
  require('../assets/car-image-1.jpg'),
  require('../assets/car-image-2.jpg'),
  require('../assets/gallery_image_3.png'),
  require('../assets/gallery_image_4.png'),
  require('../assets/car-image-3.jpg'),
  require('../assets/car-image-1.jpg'),
  require('../assets/car-image-2.jpg'),
  require('../assets/gallery_image_3.png'),
  require('../assets/gallery_image_4.png'),
  require('../assets/car-image-3.jpg'),
  require('../assets/car-image-5.jpg'),
  require('../assets/car-image-6.jpg'),
  require('../assets/image5.png'),
  require('../assets/car-image-5.jpg'),
  require('../assets/car-image-6.jpg'),

];

export default gallery;